import React, { Component } from "react";
import { withRouter } from "../utils/withRouter";
import api from "../api/index";
import { UserContext } from "../UserContext";
import CreatableSelect from "react-select/creatable";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Modal } from "antd";
import { motion } from "framer-motion";

class LocationDetails extends Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      location: {},
      error: null,
      vatm_percentage: null,
      customerTotalFee: "",
      retailLocationFee: "",
      showTooltip: false,
      showErrorMessage: false,
      registration_id: this.props.params.registration_id,
      hours: {
        Sat: { closed: false, open: "--:--", close: "--:--" },
        Sun: { closed: false, open: "--:--", close: "--:--" },
        Mon: { closed: false, open: "--:--", close: "--:--" },
        Tues: { closed: false, open: "--:--", close: "--:--" },
        Wed: { closed: false, open: "--:--", close: "--:--" },
        Thur: { closed: false, open: "--:--", close: "--:--" },
        Fri: { closed: false, open: "--:--", close: "--:--" },
      },
      business_type: "",
      // NEW: hours validation UI
      hoursErrorDays: [],
      hoursErrorMessage: "",
    };
  }

  componentDidMount() {
    const { registration_id } = this.props.params;
    const user = this.context.user;
    this.setState({
      vatm_percentage: user.vatm_percentage,
    });

    fetch(
      `${api.main}api/agent/location_details?registration_id=${registration_id}&access_token=${user.access_token}`,
      {
        method: "GET",
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error("Not found");
        return res.json();
      })
      .then((data) => {
        const locationData = {
          ...(data.data.user || null),
          ...(data.data.agent || null),
          contact_name: data.data.contact?.name || null,
          contact_phone: data.data.contact?.phone || null,
          contact_email: data.data.contact?.email || null,
          ...(data.data.account || null),
          vatm_fee: data.data.fee || null,
          split: data.data.split || null,
        };

        this.setState({
          customerTotalFee: data.data.fee,
          retailLocationFee: data.data.split,
        });

        const { available_days, start_time, end_time } = data.data.agent || {};

        const updatedState = {
          location: locationData,
          business_type: data.data.agent?.business_type || "",
          loading: false,
        };

        if (available_days && start_time && end_time) {
          const days = [
            "Sun",
            "Mon",
            "Tues",
            "Wed",
            "Thur",
            "Fri",
            "Sat",
          ];
          const availableArray = available_days
            .split(",")
            .map((s) => s.trim().replace(/^"|"$/g, ""));
          const startArray = start_time
            .split(",")
            .map((s) => s.trim().replace(/^"|"$/g, ""));
          const endArray = end_time
            .split(",")
            .map((s) => s.trim().replace(/^"|"$/g, ""));

          const hours = {};
          days.forEach((day, i) => {
            const isClosed = availableArray[i] === "0";
            hours[day] = {
              closed: isClosed,
              open: isClosed || !startArray[i] ? "--:--" : startArray[i],
              close: isClosed || !endArray[i] ? "--:--" : endArray[i],
            };
          });

          updatedState.hours = hours;
          updatedState.location.available_days = available_days;
          updatedState.location.start_time = start_time;
          updatedState.location.end_time = end_time;
        }

        this.setState(updatedState);
      })
      .catch((err) => {
        this.setState({ error: err.message, loading: false });
      });
  }

  applyDayToAll = (sourceDay) => {
    this.setState((prev) => {
      const source = prev.hours[sourceDay];
      if (!source) return null;

      const updated = { ...prev.hours };

      Object.keys(updated).forEach((day) => {
        const current =
          updated[day] || { closed: false, open: "--:--", close: "--:--" };
        const isClosed = !!current.closed;

        updated[day] = {
          ...current,
          // keep closed days closed, but copy times for open days
          open: isClosed ? "--:--" : source.open,
          close: isClosed ? "--:--" : source.close,
        };
      });

      return { hours: updated };
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      location: {
        ...prev.location,
        [name]: value,
      },
    }));
  };

  handleHoursChange = (day, field, value) => {
    this.setState((prevState) => {
      const prevDayData = prevState.hours[day];

      // If toggling "closed", reset open/close to "--:--"
      if (field === "closed" && value === true) {
        return {
          hours: {
            ...prevState.hours,
            [day]: {
              closed: true,
              open: "--:--",
              close: "--:--",
            },
          },
        };
      }

      // If re-opening a previously closed day
      if (field === "closed" && value === false) {
        return {
          hours: {
            ...prevState.hours,
            [day]: {
              ...prevDayData,
              closed: false,
            },
          },
        };
      }

      // Standard case: updating open/close times
      return {
        hours: {
          ...prevState.hours,
          [day]: {
            ...prevDayData,
            [field]: value,
          },
        },
      };
    });
  };

  // NEW: Copy Monday’s hours to all other days
  copyMondayHours = () => {
    this.setState((prev) => {
      const monday = prev.hours.Monday;
      if (!monday) return null;

      const newHours = { ...prev.hours };
      Object.keys(newHours).forEach((day) => {
        if (day === "Monday") return;
        newHours[day] = {
          ...newHours[day],
          closed: monday.closed,
          open: monday.closed ? "--:--" : monday.open,
          close: monday.closed ? "--:--" : monday.close,
        };
      });

      return { hours: newHours };
    });
  };

  // NEW: validate hours like in ManualUpload — every day must be Closed OR have both open & close
  validateHours = () => {
    const { hours } = this.state;
    const daysOrder = [
      "Sun",
      "Mon",
      "Tues",
      "Wed",
      "Thur",
      "Fri",
      "Sat",
    ];
    const invalid = [];

    daysOrder.forEach((day) => {
      const dayData = hours[day] || {};
      const isClosed = !!dayData.closed;
      const open = dayData.open;
      const close = dayData.close;

      if (!isClosed) {
        const missingOpen = !open || open === "--:--";
        const missingClose = !close || close === "--:--";
        if (missingOpen || missingClose) {
          invalid.push(day);
        }
      }
    });

    if (invalid.length > 0) {
      this.setState({
        hoursErrorDays: invalid,
        hoursErrorMessage: `Please set an opening and closing time or mark as Closed for: ${invalid.join(
          ", "
        )}.`,
      });
      return false;
    }

    this.setState({
      hoursErrorDays: [],
      hoursErrorMessage: "",
    });
    return true;
  };

  generateTimeOptions = () => {
    const options = [
      <option key="--:--" value="--:--">
        --:--
      </option>,
    ];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 30) {
        const label = `${h}:${m.toString().padStart(2, "0")}`;
        options.push(
          <option key={label} value={label}>
            {label}
          </option>
        );
      }
    }
    return options;
  };

  calculateSparesFee = () => {
    const { customerTotalFee, vatm_percentage } = this.state;
    const customerFee = parseFloat(customerTotalFee) || 0;
    const sparesFeePercent = vatm_percentage;
    return customerFee * (sparesFeePercent / 100);
  };

  calculateYourNetFee = () => {
    const { customerTotalFee, retailLocationFee } = this.state;
    const customerFee = parseFloat(customerTotalFee) || 0;
    const retailFee = parseFloat(retailLocationFee) || 0;
    const sparesFee = this.calculateSparesFee();
    return customerFee - retailFee - sparesFee;
  };

  handleFeeInputChange = (field, value) => {
    const numericValue = value.replace(/[^0-9.]/g, "");

    if (field === "customerTotalFee") {
      this.setState({
        [field]: numericValue,
        retailLocationFee: "",
        showErrorMessage: false,
      });
    } else {
      this.setState({ [field]: numericValue });
    }
  };

  handleRetailLocationFeeChange = (value) => {
    const { customerTotalFee, vatm_percentage } = this.state;
    const customerFee = parseFloat(customerTotalFee) || 0;

    if (customerFee <= 0) {
      return;
    }

    const numericValue = value.replace(/[^0-9.]/g, "");
    const sparesFee = customerFee * (vatm_percentage / 100);
    const maxAllowed = customerFee - sparesFee;

    if (numericValue === "" || numericValue === ".") {
      this.setState({
        retailLocationFee: numericValue,
        showErrorMessage: false,
      });
      return;
    }

    const inputValue = parseFloat(numericValue);

    if (!isNaN(inputValue) && inputValue <= maxAllowed) {
      this.setState({
        retailLocationFee: numericValue,
        showErrorMessage: false,
      });
    } else if (!isNaN(inputValue) && inputValue > maxAllowed) {
      this.setState({ showErrorMessage: true });
      setTimeout(() => {
        this.setState({ showErrorMessage: false });
      }, 3000);
    }
  };

  getMaxAllowedRetailFee = () => {
    const { customerTotalFee, vatm_percentage } = this.state;
    const customerFee = parseFloat(customerTotalFee) || 0;
    const sparesFee = customerFee * (vatm_percentage / 100);
    return customerFee - sparesFee;
  };

  handleRetailLocationFocus = () => {
    const { customerTotalFee } = this.state;
    if (!customerTotalFee || parseFloat(customerTotalFee) <= 0) {
      this.setState({ showTooltip: true });
    }
  };

  handleRetailLocationBlur = () => {
    this.setState({ showTooltip: false });
  };

  handleSave = () => {
    const {
      location,
      registration_id,
      business_type,
      hours,
      customerTotalFee,
      retailLocationFee,
    } = this.state;
    const access_token = this.context.user.access_token;

    // FIRST: validate hours like ManualUpload
    const hoursOk = this.validateHours();
    if (!hoursOk) return;

    const days = [
      "Sun",
      "Mon",
      "Tues",
      "Wed",
      "Thur",
      "Fri",
      "Sat",
    ];

    const available_days = days
      .map((day) => (hours[day].closed ? "0" : "1"))
      .join(",");
    const start_time = days
      .map((day) => (hours[day].closed ? "" : hours[day].open))
      .join(",");
    const end_time = days
      .map((day) => (hours[day].closed ? "" : hours[day].close))
      .join(",");

    const updatedPayload = {
      ...location,
      business_type,
      available_days,
      start_time,
      end_time,
      vatm_fee: customerTotalFee,
      split: retailLocationFee,
      registration_id,
      access_token,
    };

    fetch(`${api.main}api/agent/update_location`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...updatedPayload }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Update failed");
        return res.json();
      })
      .then(() => {
        Modal.success({
          title: "Success!",
          content:
            "Updated location information successfully. Reload the page if changes are not automatically shown.",
        });
      })
      .catch((err) =>
        Modal.error({
          title: "Error",
          content: err.message || "Failed to update. Please try again.",
        })
      );
  };

  render() {
    const {
      loading,
      error,
      location,
      business_type,
      vatm_percentage,
      customerTotalFee,
      retailLocationFee,
      hoursErrorMessage,
      hoursErrorDays,
    } = this.state;

    if (loading) return <p>Loading...</p>;
    if (error) return <p className="error-text">{error}</p>;

    const daysOrder = [
      "Sun",
      "Mon",
      "Tues",
      "Wed",
      "Thur",
      "Fri",
      "Sat",
    ];

    return (
      <div>
        <div className="location-details">
          <h2>Edit Location: {location.business_name}</h2>

          <h3>Business Information</h3>
          <div className="location-section">
            <div className="location-item">
              <label>Business Name*</label>
              <input
                className="location-input"
                type="text"
                name="business_name"
                placeholder="Business Name *"
                value={location.business_name || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Business Type</label>
              <CreatableSelect
                isClearable
                styles={{
                  container: (base) => ({
                    ...base,
                    margin: 0,
                  }),
                  control: (base) => ({
                    ...base,
                    borderRadius: "12px",
                    minHeight: "42px",
                    boxShadow: "none",
                    fontSize: "1rem",
                    fontWeight: "lighter",
                    borderColor: "#cccccc",
                    margin: 0,
                  }),
                  input: (base) => ({
                    ...base,
                    padding: "0px",
                    margin: 0,
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: "0px 8px",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    padding: "0px 4px",
                  }),
                }}
                options={[
                  { value: "Food - Restaurant", label: "Food - Restaurant" },
                  { value: "Food - Deli / Bodega", label: "Food - Deli / Bodega" },
                  {
                    value: "Shop & Service - Car Wash",
                    label: "Shop & Service - Car Wash",
                  },
                  {
                    value: "Shop & Service - Convenience",
                    label: "Shop & Service - Convenience",
                  },
                  {
                    value: "Shop & Service - Gas Station",
                    label: "Shop & Service - Gas Station",
                  },
                ]}
                value={
                  business_type
                    ? { value: business_type, label: business_type }
                    : null
                }
                onChange={(selectedOption) =>
                  this.setState({
                    business_type: selectedOption ? selectedOption.value : "",
                  })
                }
                placeholder="Business Type"
              />
            </div>
          </div>

          <div className="location-section">
            <div className="location-item">
              <label>Address*</label>
              <input
                className="location-input"
                type="text"
                name="address"
                placeholder="ex: 1234 Example Drive"
                value={location.address || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>City*</label>
              <input
                className="location-input"
                type="text"
                name="city"
                placeholder="ex: Example City"
                value={location.city || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>State*</label>
              <input
                className="location-input"
                type="text"
                name="state"
                placeholder="ex: CA"
                value={location.state || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Zipcode*</label>
              <input
                className="location-input"
                type="text"
                name="zipcode"
                placeholder="ex: 91601"
                value={location.zipcode || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Country*</label>
              <input
                className="location-input"
                type="text"
                name="country"
                placeholder="ex: United States of America"
                value={location.country || ""}
                onChange={this.handleInputChange}
              />
            </div>
          </div>

          <div className="location-section">
            <div className="location-item">
              <label>Daily Cash Limit ($)</label>
              <input
                className="location-input"
                type="text"
                name="daily_cash_limit"
                placeholder="Maximum Daily Amount"
                value={location.daily_cash_limit || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Customer's Fee ($)</label>
              <input
                type="text"
                className="location-input"
                value={customerTotalFee || ""}
                onChange={(e) =>
                  this.handleFeeInputChange("customerTotalFee", e.target.value)
                }
                placeholder="0.00"
              />
            </div>
            <div className="location-item" style={{ position: "relative" }}>
              <label>Retail Location Fee ($)</label>
              <input
                type="text"
                value={retailLocationFee || ""}
                placeholder="0.00"
                onChange={(e) =>
                  this.handleRetailLocationFeeChange(e.target.value)
                }
                onFocus={this.handleRetailLocationFocus}
                onBlur={this.handleRetailLocationBlur}
                disabled={
                  !customerTotalFee || parseFloat(customerTotalFee) <= 0
                }
                className="location-input"
                style={{
                  backgroundColor:
                    !customerTotalFee || parseFloat(customerTotalFee) <= 0
                      ? "#f5f5f5"
                      : "white",
                  cursor:
                    !customerTotalFee || parseFloat(customerTotalFee) <= 0
                      ? "not-allowed"
                      : "text",
                  borderColor: this.state.showErrorMessage ? "#ff4444" : "",
                }}
              />
              {this.state.showTooltip && (
                <div
                  style={{
                    position: "absolute",
                    top: "-35px",
                    left: "0",
                    backgroundColor: "#333",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    zIndex: 1000,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Please input customer's fee first.
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "20px",
                      width: "0",
                      height: "0",
                      borderLeft: "5px solid transparent",
                      borderRight: "5px solid transparent",
                      borderTop: "5px solid #333",
                    }}
                  ></div>
                </div>
              )}
              {this.state.showErrorMessage && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    backgroundColor: "#ff4444",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    marginTop: "2px",
                    zIndex: 1000,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Amount cannot exceed $
                  {this.getMaxAllowedRetailFee().toFixed(2)}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "100%",
                      left: "20px",
                      width: "0",
                      height: "0",
                      borderLeft: "5px solid transparent",
                      borderRight: "5px solid transparent",
                      borderBottom: "5px solid #ff4444",
                    }}
                  ></div>
                </div>
              )}
            </div>
            <div className="location-item">
              <label>Spare's Fee ({vatm_percentage}%)</label>
              <div
                className="location-input"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                ${this.calculateSparesFee().toFixed(2)}
              </div>
            </div>
            <div className="location-item">
              <label>Your Net Fee ($)</label>
              <div
                className="location-input"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                ${this.calculateYourNetFee().toFixed(2)}
              </div>
            </div>
          </div>

          {/* HOURS OF OPERATION */}
          <h3>Hours of Operation*</h3>

          {/* <div style={{ marginBottom: "8px" }}>
            <button
              type="button"
              className="btn btn-secondary"
              style={{ borderRadius: 12, padding: "4px 10px", fontSize: "0.85rem" }}
              onClick={() => applyDayToAll("Monday")}
            >
              Copy to all days
            </button>
          </div> */}

          {hoursErrorMessage && (
            <div
              style={{
                marginTop: "0.5rem",
                marginBottom: "0.5rem",
                padding: "8px 12px",
                backgroundColor: "#ffe6e9",
                color: "#d93025",
                borderRadius: "6px",
                fontSize: "0.9rem",
              }}
            >
              {hoursErrorMessage}
            </div>
          )}

          <div
            className="hours-section"
          >
            {daysOrder.map((day) => {
              const dayData =
                this.state.hours[day] || {
                  open: "--:--",
                  close: "--:--",
                  closed: false,
                };
              const hasError = hoursErrorDays.includes(day);

              const openVal =
                dayData.open && dayData.open !== "--:--" ? dayData.open : "";
              const closeVal =
                dayData.close && dayData.close !== "--:--" ? dayData.close : "";

              return (
                <div
                  key={day}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "8px 10px",
                    borderRadius: "10px",
                    border: `1px solid ${
                      hasError ? "#d93025" : "#e0e0e0"
                    }`,
                    backgroundColor: "#fafafa",
                  }}
                >
                  {/* Day label + Closed toggle */}
                  <label
                    style={{
                      width: "100%",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 4,
                      color: hasError ? "#d93025" : "inherit",
                    }}
                  >
                    <span>{day}</span>
                    <span style={{ fontSize: "0.8rem" }}>
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={!!dayData.closed}
                          onChange={(e) =>
                            this.handleHoursChange(
                              day,
                              "closed",
                              e.target.checked
                            )
                          }
                          style={{ accentColor: "var(--light-blue)" }}
                        />
                        Closed
                      </label>
                    </span>
                  </label>

                  {/* Stacked time inputs */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 4,
                      marginTop: 4,
                    }}
                  >
                    <input
                      type="time"
                      step="1800"
                      value={openVal}
                      disabled={!!dayData.closed}
                      onChange={(e) =>
                        this.handleHoursChange(day, "open", e.target.value)
                      }
                      style={{
                        borderRadius: "8px",
                        padding: "4px 6px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <input
                      type="time"
                      step="1800"
                      value={closeVal}
                      disabled={!!dayData.closed}
                      onChange={(e) =>
                        this.handleHoursChange(day, "close", e.target.value)
                      }
                      style={{
                        borderRadius: "8px",
                        padding: "4px 6px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 4,
                      marginTop: 4,
                    }}
                  >
                    <motion.button
                      type="button"
                      className="btn btn-secondary"
                      style={{
                        borderRadius: 5,
                        padding: "4px 10px",
                        fontSize: "0.85rem",
                      }}
                      onClick={() => this.applyDayToAll(day)}
                    >
                      Copy to all
                    </motion.button>
                  </div>
                </div>
              );
            })}
          </div>

          <h3>Contact Information</h3>
          <div className="location-section">
            <div className="location-item">
              <label>Contact Name*</label>
              <input
                className="location-input"
                type="text"
                name="contact_name"
                placeholder="Contact Name *"
                value={location.contact_name || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Contact Email*</label>
              <input
                className="location-input"
                type="email"
                name="contact_email"
                placeholder="Email *"
                value={location.contact_email || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Contact Phone*</label>
              <PhoneInput
                country={"us"}
                value={location.contact_phone || ""}
                inputProps={{ name: "contact_phone" }}
                onChange={(value) =>
                  this.handleInputChange({
                    target: { name: "contact_phone", value: "+" + value },
                  })
                }
                inputClass="custom-phone-input"
                buttonClass="custom-phone-button"
                containerClass="custom-phone-container"
              />
            </div>
          </div>

          <h3>Banking Details</h3>
          <div className="location-section">
            <div className="location-item">
              <label>Bank Name</label>
              <input
                className="location-input"
                type="text"
                name="bank_name"
                placeholder="Bank Name"
                value={location.bank_name || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Account Holder Name</label>
              <input
                className="location-input"
                type="text"
                name="account_holder_name"
                placeholder="Account Holder Name"
                value={location.account_holder_name || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Account Number</label>
              <input
                className="location-input"
                type="text"
                name="account_number"
                placeholder="Account Number"
                value={location.account_number || ""}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="location-item">
              <label>Routing Number</label>
              <input
                className="location-input"
                type="text"
                name="routing_number"
                placeholder="Routing Number"
                value={location.routing_number || ""}
                onChange={this.handleInputChange}
              />
            </div>
          </div>

        <div className="location-section">
          <button className="btn btn-secondary" style={{width: "200px"}} onClick={()=> (this.props.navigate("/view-locations"))}>Go Back</button>
          <button className="btn btn-primary" style={{width: "200px"}} onClick={this.handleSave}>Save Changes</button>
        </div>
      </div>
      </div>
    );
  }
}

export default withRouter(LocationDetails);
